import {
  NON_PATIENT_ACTIVITY_TYPE_UPDATE_REQUEST,
  NON_PATIENT_ACTIVITY_TYPE_UPDATE_SUCCESS,
  NON_PATIENT_ACTIVITY_TYPE_UPDATE_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';

export function updateNonPatientActivityType(activityTypeId) {
  return {
    types: [
      NON_PATIENT_ACTIVITY_TYPE_UPDATE_REQUEST,
      NON_PATIENT_ACTIVITY_TYPE_UPDATE_SUCCESS,
      NON_PATIENT_ACTIVITY_TYPE_UPDATE_FAILURE,
    ],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      data: activityTypeId,
      path: 'v1/command/EditNonPatientActivityType',
    }),
  };
}
